import React from 'react';
import { FloatingModal as FloatingModalNew } from './FloatingModal';
import { convertOldFloatingModalProps } from './converter.old';
import type { OldFloatingModalProps } from './converter.old';

export type FloatingModalProps = OldFloatingModalProps;

export const FloatingModal = (props: React.PropsWithChildren<FloatingModalProps>) => (
  <FloatingModalNew {...convertOldFloatingModalProps(props)} />
);
